import en from './en/translation'
import et from './et/translation'
import fi from './fi/translation'
import lt from './lt/translation'
import lv from './lv/translation'
import no from './no/translation'
import sv from './sv/translation'

export default {
    en,
    et,
    fi,
    lt,
    lv,
    no,
    sv
}
